import React from 'react';

import { AddressValidationStatus } from '../../pages/LeadsManagement/types';
import StatusBadgeIcon from './StatusBadgeIcon';

interface AddressIconProps {
    status?: AddressValidationStatus | string | null;
}

const AddressIcon: React.FC<AddressIconProps> = ({ status }) => {
    const validated = status === 'validated';
    return (
        <StatusBadgeIcon
            done={validated}
            title={validated ? 'Address validated' : 'Address unvalidated'}
        />
    );
};

export default AddressIcon;
